import { api } from "@shared/api/client";

export type CleanupType = "chats" | "justifications" | "clockings" | "vacations";

export type CleanupFilters = {
  q?: string;
  from?: string;
  to?: string;
  status?: string;
};

export type CleanupItem = {
  id: number;
  title: string;
  subtitle: string | null;
  date: string | null;
  status: string | null;
  details: string | null;
  warning: string | null;
};

export type CleanupListResponse = {
  data: CleanupItem[];
  meta: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
};

export type CleanupSummary = Record<CleanupType, number>;

export async function getCleanupSummary(): Promise<CleanupSummary> {
  const { data } = await api.get<{ data: CleanupSummary }>("/settings/data-cleanup/summary");
  return data.data;
}

export async function getCleanupItems(
  type: CleanupType,
  page: number,
  filters: CleanupFilters,
): Promise<CleanupListResponse> {
  const { data } = await api.get<CleanupListResponse>(`/settings/data-cleanup/${type}`, {
    params: {
      page,
      q: filters.q || undefined,
      from: filters.from || undefined,
      to: filters.to || undefined,
      status: filters.status || undefined,
    },
  });

  return data;
}

export async function deleteCleanupItems(params: {
  type: CleanupType;
  ids: number[];
  all: boolean;
  filters: CleanupFilters;
}): Promise<{
  ok: boolean;
  deleted: number;
  related_deleted: number;
  file_errors: number;
  message: string;
}> {
  const { data } = await api.post(`/settings/data-cleanup/${params.type}/delete`, {
    ids: params.all ? undefined : params.ids,
    all: params.all,
    filters: params.filters,
  });

  return data;
}
